import React from 'react'
import { useRouter } from 'next/router'
import { GetServerSideProps } from 'next'

import SubMenuPage from '@features/faq/pages/SubMenuPage'
import { BASE_URL } from '@configs/config'
import { maintenanceHandler } from '@lib/maintenanceHandler'

const howToMenus = [
  { title: 'สมัครสมาชิก', url: '/faq/how-to?content=register' },
  { title: 'ลืมรหัสผ่าน', url: '/faq/how-to?content=forgotPassword' },
  {
    title: 'เปลี่ยนรหัสผ่านจากเว็บไซต์',
    url: '/faq/how-to?content=changePassword',
  },
  {
    title: 'เพราะอะไรฉันถึงเปลี่ยนรหัสผ่านไม่ได้ / กดลืมรหัสผ่านไม่ได้',
    url: '/faq/how-to?content=forgotPasswordFailed',
  },
  {
    title: 'เพราะอะไรฉันถึงเปลี่ยนชื่อผู้ใช้งานไม่ได้',
    url: '/faq/how-to?content=changeDisplayNameFailed',
  },
]

type ContentType =
  | 'register'
  | 'forgotPassword'
  | 'changePassword'
  | 'forgotPasswordFailed'
  | 'changeDisplayNameFailed'

const contents = {
  register: (
    <div>
      <h1>สมัครสมาชิก</h1>
      <ol>
        <li>
          <p>
            กดที่
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เข้าสู่ระบบ/สมัครสมาชิก&rdquo;&nbsp;
            </span>
            &nbsp;(กรณีใช้แอปพลิเคชัน กดที่รูปโปรไฟล์ แล้วกด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เข้าสู่ระบบ/สมัครสมาชิก&rdquo;
            </span>
            )
          </p>
        </li>
        <li>
          <p>เลือกเชื่อมบัญชีเพื่อสมัครสมาชิก&nbsp;โดยมีช่องทางดังนี้</p>
        </li>
      </ol>
      <ul>
        <li>
          <p>บัญชีนายอินทร์</p>
        </li>
        <li>
          <p>บัญชีเฟซบุ๊ค</p>
        </li>
        <li>
          <p>บัญชีไลน์</p>
        </li>
        <li>
          <p>บัญชีแอปเปิ้ล (Apple ID)</p>
        </li>
        <li>
          <p>บัญชีกูเกิล (gmail)</p>
        </li>
      </ul>
      <ol start={3}>
        <li>
          <p>
            หรือสมัครผ่านอีเมลอื่นๆ&nbsp;&nbsp;โดยกด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;สมัครสมาชิก&rdquo;&nbsp;
            </span>
            และกรอกข้อมูลให้ครบถ้วน และ
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ตั้งรหัสผ่าน&rdquo;
            </span>{' '}
            เงื่อนไขการตั้งรหัสผ่าน: ความยาวอย่างน้อย 8 ตัวอักษร ประกอบด้วย
          </p>
        </li>
      </ol>
      <ul>
        <li>
          <p>ตัวอักษรพิมพ์เล็ก (a-z) อย่างน้อย 1 ตัว</p>
        </li>
        <li>
          <p>ตัวอักษรพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัว</p>
        </li>
        <li>
          <p>มีตัวเลข และอักขระพิเศษ (@$!%*?&amp;_.) อย่างน้อย 1 ตัว</p>
        </li>
      </ul>
      <br />
      <p className='underline'>ตัวอย่างบนเว็บไซต์</p>
      <br />
      <img
        src='/images/faq/image7.png'
        className='max-w-[900px] w-full'
        alt='Register faq'
      />
    </div>
  ),
  forgotPassword: (
    <div>
      <h1>ลืมรหัสผ่าน</h1>
      <ol>
        <li>
          <p>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เข้าสู่ระบบ/สมัครสมาชิก&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ลืมรหัสผ่าน&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            กรอก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;อีเมล&rdquo;&nbsp;
            </span>
            ที่สมัครไว้
          </p>
        </li>
        <li>
          <p>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ส่งข้อมูล&rdquo;&nbsp;
            </span>
            จากนั้นระบบจะส่งลิงก์ให้ทางอีเมล เพื่อตั้งรหัสผ่านใหม่
            (กรุณาตรวจสอบที่อีเมลของท่าน หากไม่พบสามารถตรวจสอบได้ที่ Junk Mail /
            Spam Mail)
          </p>
        </li>
        <li>
          <p>
            กดลิงก์ที่ได้รับจากอีเมล จากนั้น&nbsp;กรอก
            <span className='text-primary font-medium'>
              &ldquo;รหัสผ่านใหม่&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            กรอก{' '}
            <span className='text-primary font-medium'>
              &ldquo;รหัสผ่านใหม่&rdquo;
            </span>{' '}
            อีกครั้ง&nbsp;เพื่อยืนยัน
          </p>
        </li>
        <li>
          <p>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;บันทึกรหัสผ่านใหม่&rdquo;
            </span>
          </p>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <p className='underline'>ตัวอย่างบนเว็บไซต์</p>
      <p>
        <br />
      </p>
      <img
        src='/images/faq/image3.png'
        alt='Forgot password faq'
        className='max-w-[900px] w-full'
      />
      <img
        src='/images/faq/image11.png'
        alt='Forgot password faq'
        className='max-w-[900px] w-full'
      />
      <img
        src='/images/faq/image14.png'
        alt='Forgot password faq'
        className='max-w-[900px] w-full'
      />
    </div>
  ),
  changePassword: (
    <div>
      <h1>เปลี่ยนรหัสผ่านจากเว็บไซต์</h1>
      <ol>
        <li>
          <p>
            กดที่
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ตั้งค่าโปรไฟล์&rdquo;&nbsp;
            </span>
            เลือกหน้าข้อมูลส่วนตัว &nbsp;
          </p>
        </li>
        <li>
          <p>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เปลี่ยนรหัสผ่าน&rdquo;&nbsp;
            </span>
            เพื่อตั้งค่ารหัสผ่านใหม่
          </p>
        </li>
        <li>
          <p>
            กรอก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รหัสผ่านเดิม&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            กรอก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รหัสผ่านใหม่&rdquo;&nbsp;
            </span>
            และกรอก{' '}
            <span className='text-primary font-medium'>
              {' '}
              &ldquo;ยืนยันรหัสผ่าน&rdquo;
            </span>{' '}
            อีกครั้ง
          </p>
        </li>
        <li>
          <p>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ยืนยัน&rdquo;&nbsp;
            </span>
            เพื่อบันทึกการเปลี่ยนแปลง
          </p>
        </li>
      </ol>
      <p>
        <br />
      </p>
    </div>
  ),
  forgotPasswordFailed: (
    <div>
      <h1>เพราะอะไรฉันถึงเปลี่ยนรหัสผ่านไม่ได้ / กดลืมรหัสผ่านไม่ได้</h1>
      <ul>
        <li>
          <p>รหัสผ่านใหม่ที่ตั้งอาจจะตรงกับรหัสผ่านเดิม ทำให้แก้ไขไม่ได้</p>
        </li>
        <li>
          หากพบกรณีดังกล่าว กรุณาติดต่อแอดมินเพื่อช่วยเหลือคุณได้ที่&nbsp;
          <a
            href='mailto:read.support@mareads.com'
            className='text-primary underline'
          >
            read.support@mareads.com
          </a>
        </li>
      </ul>
    </div>
  ),
  changeDisplayNameFailed: (
    <div>
      <h1>เพราะอะไรฉันถึงเปลี่ยนชื่อผู้ใช้งานไม่ได้</h1>
      <p>ชื่อผู้ใช้ / ชื่อที่แสดงให้ผู้อื่นเห็น มีข้อจำกัดดังนี้</p>
      <ul>
        <li>
          <p>จำกัดจำนวนตัวอักษรและตัวเลข ระหว่าง 5 - 50 ตัวอักษร</p>
        </li>
        <li>
          <p>ต้องเป็นภาษาอังกฤษ หรือตัวเลข และไม่มีเว้นวรรค</p>
        </li>
      </ul>
    </div>
  ),
}

const defaultBreadCrumb = [
  { title: 'คำถามที่พบบ่อย', url: '/faq' },
  { title: 'การใชังาน', url: '/faq/how-to' },
]

function HowTo({ url }: { url: string }) {
  const { query } = useRouter()

  return (
    <SubMenuPage
      menus={howToMenus}
      breadCrumbList={
        query?.content
          ? [
              ...defaultBreadCrumb,
              {
                title:
                  howToMenus.find(m => m.url.includes(String(query.content)))
                    ?.title || '',
                url:
                  howToMenus.find(m => m.url.includes(String(query.content)))
                    ?.url || '',
              },
            ]
          : defaultBreadCrumb
      }
      content={contents[query?.content as ContentType]}
      url={url}
    />
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return maintenanceHandler({
    url: `${BASE_URL}${req.url}`,
  })
}

export default HowTo
